import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance, axiosInstance, axiosScraper } from '@utils/axios/axiosInstance';
import { fetchAppInfoParamsType, fetchCompetitorAppsParamsType } from '@models/auth/authModel';
import { ISearchResponse } from '../../models/scraperModel/searchModel';
import { IMyAppInfoListRequestParamsModel, IMyAppInfoCountryRequestParamsModel } from '@models/manager/service/app';
import { IResponseRegisteredAppInfo, IAllMyAppListObj } from '@models/manager/service/serviceModel';
import { getHttpResponseResult } from '@utils/axios/httpResponseHelper';
import { result } from 'lodash';

//[POST]GNB Search Result App 을 MyApp 으로 등록 시.
//TODO: Layout 으로 옮겨야함..
export const fetchRegisterMyApp = createAsyncThunk(
  'fetchRegisterMyApp',
  async (params: ISearchResponse, { rejectWithValue }) => {
    try {
      // // 아래는 실제 연결 시킨것
      // const response = await axiosInstance.post('/', params);
      const response = await axiosDummyInstance.get('/api/commonGetResponse.json');
      const { success, data } = getHttpResponseResult<ISearchResponse>(response, 'result');
      if (success && data) {
        return data;
      } else {
        return rejectWithValue('An error occurred');
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// myAppInfoList에 myApp 을 추가하는 함수 () - 이 함수 이후 slice 에서 처리하는건 없다.
// TODO: 이 함수가 성공적으로 추가된 이후 MyAppList 요청 다시하기
export const fetchAddMyAppInfoList = createAsyncThunk(
  'fetchAddMyAppInfoList',
  async (params: { appId: string; provider_type: string; userId: string }) => {
    try {
      // TODO: 추후 연결처리하기(POST 요청으로 DB에 보내기)
      const { status, data } = await axiosDummyInstance.get('/api/commonGetResponse.json');
      if (status === 200) {
        return params;
      }
    } catch (error) {}
  }
);

// [DELETE] myAppInfoList 에서 myApp 을 삭제하는 함수
export const deleteMyAppInAppInfoList = createAsyncThunk(
  'deleteMyAppInAppInfoList',
  async (
    params: { appId: string; providerType: string; userId: string; appSeq: string | number },
    { rejectWithValue }
  ) => {
    try {
      // TODO: 추후 연결처리하기 (slice에서 리스트 목록 삭제처리)
      // const response = await axiosInstance.delete('/app/my', { data: params });
      const response = await axiosDummyInstance.get('/api/commonGetResponse.json');
      const { success, data } = getHttpResponseResult<{ result: boolean; message: string }>(response);
      if (success) {
        return params;
      } else {
        return rejectWithValue(data);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// [GET] App Manager > My Apps 의 내앱-경쟁자앱들  목록 가져오기
// myAppList 기준으로 promiseAll 을 사용하여 내가 등록한 app, competitorsApp 을 가져온다.
// serviceSlice 의 allMyAppListInfo 에 넣을 데이터 받아서 조합 후 slice로 넘기기
export const getAllMyAppsListInfo = createAsyncThunk(
  'getAllMyAppsListInfo',
  async (params: { userId: string }, { rejectWithValue }) => {
    try {
      // const { data: responseAllMyAppList, status: statuesAllMyAppList } = await axiosInstance.get('/app/my/competitor');
      const { data: responseAllMyAppList, status: statuesAllMyAppList } = await axiosDummyInstance.get(
        '/api/myAppsInfoObjList.json'
      );
      if (statuesAllMyAppList === 200) {
        // 여기서 promiseAll 로  store integration 부분에 대해 다시 요청하기
        const result = await Promise.all(
          responseAllMyAppList.map(async (appObj) => {
            // TODO: 아래는 store integration 연결 API 부분
            const { data: responseCheckStore, status: statusCheckStore } = await axiosDummyInstance.get(
              '/api/commonGetResponse.json'
            );
            if (statusCheckStore === 200) {
              return {
                ...appObj,
                IsConnectStoreIntegration: [true, false][Math.round(Math.random())],
              };
            }
          })
        );
        return result;
      } else {
        return rejectWithValue(responseAllMyAppList);
      }
    } catch (error) {
      console.log('error: ', error);
      return rejectWithValue(error);
    }
  }
);
